import { Game } from './game/Game.js';

// Block iOS Safari's pinch-zoom via the gesture events (the viewport meta
// alone isn't always honoured on newer iOS versions). Single-finger touches
// don't fire these, so nipplejs still works for the joystick.
for (const evt of ['gesturestart', 'gesturechange', 'gestureend']) {
  document.addEventListener(evt, (e) => e.preventDefault(), { passive: false });
}
// Block ctrl/cmd + wheel zoom on desktop browsers too.
window.addEventListener('wheel', (e) => {
  if (e.ctrlKey) e.preventDefault();
}, { passive: false });
// Note: the touchend double-tap blocker that used to live here interfered
// with nipplejs's touchend handling on iOS (the joystick stopped
// registering input). Double-tap zoom is already blocked by
// touch-action: none on html/body and the viewport meta, so the
// blanket touchend preventDefault is redundant and harmful.

document.addEventListener('DOMContentLoaded', async () => {
  console.log('Initializing snowboarding game...');
  const game = new Game();
  await game.init();
  console.log('Ready.');
});
